<template>
  <el-dialog
    title="Thêm mới thiết bị AI"
    :before-close="handleClose"
    :visible.sync="isOpen"
    :show-close="true"
    :close-on-click-modal="false"
    width="800px"
    top="5vh"
    custom-class="modern-dialog"
  >
    <div class="dialog-header-themed">
      <div class="themed-icon"><i class="el-icon-plus"></i></div>
      <div class="themed-text">
        <h3>THÊM THIẾT BỊ NHẬN DIỆN MỚI</h3>
        <p>Cung cấp cấu hình mạng và thông tin xác thực để kết nối thiết bị với hệ thống.</p>
      </div>
    </div>

    <el-form
      label-position="top"
      :model="devicesData"
      :rules="rules"
      ref="recognitionData"
      class="modern-dialog-form"
    >
      <!-- Section 1: Basic Information -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-info"></i> Thông tin cơ bản</h4>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tên thiết bị (Đầu ghi)" prop="nameDevice">
              <el-input v-model="devicesData.nameDevice" placeholder="Ví dụ: Cổng chính Hikvision" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Chọn trường liên kết" prop="idSchool">
              <el-select v-model="devicesData.idSchool" filterable placeholder="Chọn trường học" class="w-full">
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :value="item.id"
                  :label="`${item.id} - ${item.schoolName}`"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Version điểm danh">
              <el-select v-model="devicesData.versionAttendance" class="w-full">
                <el-option
                  v-for="(item, index) in listVersionAttendance"
                  :key="index"
                  :value="item.value"
                  :label="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Loại đầu ghi / Hãng" prop="typeDevice">
              <el-radio-group v-model="devicesData.typeDevice" class="modern-radio-group">
                <el-radio-button label="Hik">Hikvision</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Số Serial Number thiết bị (Device SN)" prop="deviceSN">
              <el-input v-model="devicesData.deviceSN" placeholder="Nhập số Serial của thiết bị nhận diện" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- Section 2: Network Configuration -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-share"></i> Cấu hình mạng</h4>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tên miền (Domain)" prop="schoolDomain">
              <el-input v-model.trim="devicesData.schoolDomain" placeholder="Ví dụ: hik-gate.onekids.edu.vn" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Địa chỉ IP Local" prop="ipLocal">
              <el-input v-model.trim="devicesData.ipLocal" placeholder="Ví dụ: 192.168.1.160" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="Cổng Port Local" prop="port">
              <el-input-number v-model="devicesData.port" :controls="false" placeholder="8181" class="w-full" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Port DVR" prop="portDVR">
              <el-input-number v-model="devicesData.portDVR" :controls="false" placeholder="8199" class="w-full" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Port RTSP" prop="portRTSP">
              <el-input-number v-model="devicesData.portRTSP" :controls="false" placeholder="554" class="w-full" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- Section 3: Authentication Accounts -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-key"></i> Tài khoản thiết bị & Modem</h4>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tài khoản admin đầu ghi" prop="adminAcc">
              <el-input v-model.trim="devicesData.adminAcc" placeholder="admin" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mật khẩu admin đầu ghi" prop="adminPassword">
              <el-input v-model.trim="devicesData.adminPassword" type="password" show-password placeholder="Nhập mật khẩu" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tài khoản Modem" prop="modemAcc">
              <el-input v-model.trim="devicesData.modemAcc" placeholder="Nhập tài khoản Modem" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mật khẩu Modem" prop="modemPassword">
              <el-input v-model.trim="devicesData.modemPassword" type="password" show-password placeholder="Nhập mật khẩu Modem" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- Section 4: Notes -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-notebook-2"></i> Ghi chú</h4>
        <el-form-item label="" prop="note">
          <el-input type="textarea" v-model="devicesData.note" :rows="3" placeholder="Nhập ghi chú thêm cho thiết bị..." />
        </el-form-item>
      </div>
    </el-form>

    <template #footer>
      <div class="dialog-footer-themed">
        <el-button type="danger" plain size="medium" icon="el-icon-circle-close" @click="handleClose">
          Đóng
        </el-button>
        <el-button type="success" size="medium" icon="el-icon-circle-check" :loading="loading.submit" @click="submitForm">
          Lưu lại
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import DeviceRecognitionService from "@/services/ManagerRecognition/DeviceRecognitionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: () => false
    },
    schoolList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      devicesData: {
        nameDevice: "",
        typeDevice: "Hik",
        adminAcc: "admin", // Default updated from request
        adminPassword: "",
        schoolDomain: "",
        port: 8181, // Default updated from request
        portRTSP: 554,
        portDVR: 8199, // Default updated from request
        deviceSN: "",
        macAddress: "",
        ipLocal: "",
        modemAcc: "",
        modemPassword: "",
        active: false,
        note: "",
        webhookRegister: false,
        idSchool: "",
        versionAttendance: "VERSION_1"
      },
      listVersionAttendance: [
        { id: 1, value: "VERSION_1" },
        { id: 2, value: "VERSION_2" },
        { id: 3, value: "VERSION_3" }
      ],
      rules: {
        nameDevice: [
          { required: true, message: "Tên đầu ghi không được để trống", trigger: "blur" }
        ],
        typeDevice: [
          { required: true, message: "Loại đầu ghi không được để trống", trigger: "change" }
        ],
        idSchool: [
          { required: true, message: "Trường liên kết không được để trống", trigger: "change" }
        ],
        adminAcc: [
          { required: true, message: "Tài khoản đầu ghi không được để trống", trigger: "blur" }
        ],
        adminPassword: [
          { required: true, message: "Mật khẩu không được để trống", trigger: "blur" }
        ],
        schoolDomain: [
          { required: true, message: "Tên miền không được để trống", trigger: "blur" }
        ],
        portDVR: [
          { required: true, message: "Port DVR không được để trống", trigger: "blur" }
        ],
        port: [
          { required: true, message: "Port Local không được để trống", trigger: "blur" }
        ],
        ipLocal: [
          { required: true, message: "IP local không được để trống", trigger: "blur" }
        ]
      },
      loading: {
        submit: false
      }
    };
  },

  methods: {
    handleClose() {
      this.$refs["recognitionData"].resetFields();
      // Restore defaults on close/reset
      this.devicesData = {
        nameDevice: "",
        typeDevice: "Hik",
        adminAcc: "admin",
        adminPassword: "",
        schoolDomain: "",
        port: 8181,
        portRTSP: 554,
        portDVR: 8199,
        deviceSN: "",
        macAddress: "",
        ipLocal: "",
        modemAcc: "",
        modemPassword: "",
        active: false,
        note: "",
        webhookRegister: false,
        idSchool: "",
        versionAttendance: "VERSION_1"
      };
      this.$emit("closeDialog");
    },

    async submitForm() {
      this.$refs["recognitionData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          let data = {
            nameDevice: this.devicesData.nameDevice,
            typeDevice: this.devicesData.typeDevice,
            adminAcc: this.devicesData.adminAcc,
            adminPassword: this.devicesData.adminPassword,
            schoolDomain: this.devicesData.schoolDomain,
            port: this.devicesData.port,
            portRTSP: this.devicesData.portRTSP,
            portDVR: this.devicesData.portDVR,
            deviceSN: this.devicesData.deviceSN,
            macAddress: "",
            ipLocal: this.devicesData.ipLocal,
            modemAcc: this.devicesData.modemAcc,
            modemPassword: this.devicesData.modemPassword,
            active: false,
            note: this.devicesData.note,
            webhookRegister: false,
            idSchool: parseInt(this.devicesData.idSchool),
            versionAttendance: this.devicesData.versionAttendance
          };
          
          await DeviceRecognitionService.createDeviceRecognition(data)
            .then((response) => {
              if (response.status === 200) {
                NotifyMessage.leftCornerNotificationSuccess("Thêm thiết bị thành công!");
                this.handleClose();
              } else {
                NotifyMessage.leftCornerNotificationError("Thêm thiết bị thất bại!");
              }
            })
            .catch((error) => {
              console.error(error);
              NotifyMessage.leftCornerNotificationError("Thêm thiết bị thất bại!");
            })
            .finally(() => {
              this.loading.submit = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss">
/* Modern styling for Dialog headers and layout */
.modern-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;

  .el-dialog__header {
    display: none; /* Custom header used instead */
  }

  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.dialog-header-themed {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #fff;

  .themed-icon {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.25);
    font-size: 20px;
  }

  .themed-text {
    h3 {
      margin: 0 0 4px 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    p {
      margin: 0;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.modern-dialog-form {
  padding: 24px 28px;
  max-height: 60vh;
  overflow-y: auto;
}

.form-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;

  .section-divider {
    margin: 0 0 16px 0;
    font-size: 13px;
    font-weight: 700;
    color: #3b82f6;
    display: flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 8px;
  }
}

/deep/ .el-form-item {
  margin-bottom: 16px;

  .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding: 0 0 4px 0 !important;
    font-size: 13px;
  }
  
  .el-input__inner {
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    &:focus {
      border-color: #3b82f6;
    }
  }
}

.modern-radio-group {
  /deep/ .el-radio-button__inner {
    border-radius: 6px !important;
    padding: 10px 20px;
    font-weight: 600;
  }
}

.dialog-footer-themed {
  padding: 16px 28px;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.w-full {
  width: 100%;
}
</style>